import { render, staticRenderFns } from "./SoldProducts.vue?vue&type=template&id=3477de61"
import script from "./SoldProducts.vue?vue&type=script&lang=js"
export * from "./SoldProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports